<template>
	<div class="grzx">
		<div class="aui-bg-box"></div>
		<div class="aui-user-box">
			<div class="aui-flex">
				<div class="aui-user-img"><img :src="userImg" alt="" /></div>
				<div class="aui-flex-box" v-if="isTeamOperator == 0">
					<h2>{{userName}}</h2>
					<p>{{userPhone}}</p>
				</div>
				<div class="aui-flex-box" v-if="isTeamOperator == 1">
					<h2>{{teamOperator.contactName}}</h2>
					<p>{{teamOperator.concatPhone}}</p>
				</div>
			</div>
		</div>
		<div class="aui-white-bg aui-white-bg-pa">
			<div class="grzxBlock">
				<div class="dhCard" v-if="meeting">
					<h4>{{meeting.meetingName}}</h4>
					<p><van-icon name="clock-o" />
						{{meeting.startTime.substring(0,10)+'至'+meeting.endTime.substring(0,10)}}</p>
					<p><van-icon name="location-o" /> {{meeting.meetingAddress}}</p>
				</div>
				<van-grid :column-num="isTeamOperator == 1?3:3" :border="true">
					<van-grid-item @click="chm" v-if="isTeamOperator == 0">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="erweima" size="40" color="#4DB6AC" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">参会码</p>
						</template>
					</van-grid-item>
					<van-dialog v-model:show="chmShow" theme="round-button">
						<template #title>
							<h4 style="margin:0 0 20px;font-size: 20px;">参会码</h4>
						</template>
						<div class="chmContent">
							<div class="product-hover"></div>
							<img :src="ewmUrl" alt="" class="chmewm">
							<!-- <qrcode-vue :value="ewmUrl" :size="size" level="H" class="chmewm" /> -->
						</div>
						<br>
					</van-dialog>
					<van-grid-item @click="sqxf" v-if="isTeamOperator == 0&&meeting.isScore == 1 && (entered.isSignUp == '1'||entered.userType == '5')">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="Icon-xuefentongji" size="40"
								color="#66BB6A" :badge=attr2badge />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">申请学分</p>
						</template>
					</van-grid-item>
					<!-- 跳过发票信息 2026-07-07 -->
					<!-- <van-grid-item to="/personal/sqfp" v-if="isTeamOperator == 0&&orderList.length > 0 && (entered.isSignUp == '1'||entered.transferStatus == '1')">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="fukuandanfapiao" size="40"
								color="#FFA726" :badge=invoiceInfobadge />
						</template>

						<template #text>
							<p style="color:#666;margin:5px 0;">申请发票</p>
						</template>
					</van-grid-item> -->
					<van-grid-item to="/personal/bmxx" v-if="isTeamOperator == 0">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="baomingxinxi" size="40"
								color="#42A5F5" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">报名信息</p>
						</template>
					</van-grid-item>
					<van-grid-item @click="dynamicPath('转赠')" v-if="isTeamOperator == 0 && (orderList.length>0 && orderList[0].payStatus == '1') &&new Date(meeting.changeDeadline)>new Date()&&(entered.refundStatus == 0||entered.refundStatus == 3)&&entered.transferStatus !=1">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="a-12-10zengsong" size="40" color="#a3d900" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">转赠</p>
						</template>
					</van-grid-item>
					<van-grid-item @click="enteredApplyRefund(entered.phone)" v-if="isTeamOperator == 0&&(entered.refundStatus == 0||entered.refundStatus == 3)&&entered.whoPay == 1&&entered.transferStatus !=1&&(orderList.length>0 && orderList[0].payStatus == '1')">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="shenqingtuifei" size="40" color="#dd6572" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">申请退费</p>
						</template>
					</van-grid-item>
					<van-grid-item @click="dynamicPath('团体成员管理')" v-if="isTeamOperator == 1">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="tuanduitouzhu" size="40"
								color="#ed6a0c" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">团体成员管理</p>
						</template>
					</van-grid-item>
					<!-- 0828 会议注释 -->
					<van-grid-item @click="dynamicPath('交费管理')" v-if="isTeamOperator == 1&&meeting.isBmf == 1">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="jiaofeiguanli" size="40"
								color="#ed3e87" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">交费管理</p>
						</template>
					</van-grid-item>
					<van-grid-item @click="dynamicPath('订单管理')" v-if="isTeamOperator == 1&&meeting.isBmf == 1">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="dingdan" size="40" color="#ff2d51" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">订单管理</p>
						</template>
					</van-grid-item>
					<!-- 0828 会议注释 结束 -->
					<!-- <van-grid-item @click="dynamicPath('发票管理')" v-if="isTeamOperator == 1">
						<template #icon>
							<van-icon class="iconfont" class-prefix="icon" name="fukuandanfapiao" size="40"
								color="#a3d900" />
						</template>
						<template #text>
							<p style="color:#666;margin:5px 0;">发票管理</p>
						</template>
					</van-grid-item> -->
				</van-grid>
				<div v-if="isTeamOperator == 0">
					<h4>参会信息</h4>
					<!-- 企业用户 -->
					<van-card v-if="entered.userType == 5">
						<template #title>
							<h3 style="text-align: justify;">{{meeting.meetingName}}</h3>
						</template>
						<template #desc>
							<p style="font-size: 14px;">报名时间:{{entered.crtTime}}</p>
						</template>
						<template #tag>
							<van-tag type="warning" style="font-size: 14px;">已完成</van-tag>
						</template>
						<template #price>
							<span style="font-size: 14px;color:#d00;font-weight: bold;">免费</span>
						</template>
						<template #thumb>
							<van-image :src=hyImg />
						</template>
						<template #footer>
							
						</template>
					</van-card>
					<!-- 观展用户 -->
					<van-card v-else-if="entered.userType == 7">
						<template #title>
							<h3 style="text-align: justify;margin-top:0;">{{meeting.meetingName}}</h3>
						</template>
						<template #desc>
							<p style="font-size: 14px;">报名时间:{{entered.crtTime}}</p>
						</template>
						<template #price>
							<span style="font-size: 14px;color:#d00;margin-right:20px;font-weight: bold;">{{entered.attr4?'￥'+entered.money:'免费'}}</span>
							<van-tag plain type="warning" style="font-size: 14px;" v-if="entered.attr4&&(entered.refundStatus == 0||entered.refundStatus == 3)&&entered.transferStatus!=1">{{entered.whoPay == 2?'待经办人支付':'待支付'}}</van-tag>
							<van-tag plain type="warning" style="font-size: 14px;" v-if="entered.attr4&&entered.refundStatus == 1">申请退费审核中</van-tag>
							<van-tag plain type="danger" style="font-size: 14px;" v-else-if="entered.attr4&&entered.refundStatus == 2">已退费</van-tag>
							<van-tag plain type="warning" style="font-size: 14px;" v-else-if="entered.attr4&&entered.transferStatus == 1">已转赠</van-tag>
							<!-- <van-tag type="warning" style="font-size: 14px;" v-else>已完成</van-tag> -->
						</template>
						<template #thumb>
							<van-image :src=hyImg />
						</template>
						<template #footer>
							<van-button type="danger" size="mini" style="font-size: 16px;" v-if="meeting.isScore == 1&&!entered.attr4" @click="wysj">我要学分，点击支付</van-button>
							<!-- 0828 会议注释 -->
							<van-button type="danger" size="mini" style="font-size: 16px;" v-else-if="meeting.isScore == 0&&!entered.attr4" @click="wysj">点击支付</van-button>
							<van-button type="danger" size="mini" style="font-size: 16px;" v-else-if="entered.attr4&&entered.whoPay == 1&&entered.refundStatus == 0&&entered.transferStatus==0" @click="zhifu">去支付</van-button>
						</template>
					</van-card>
					<!-- 普通参展用户 -->
					<div v-else-if="entered.userType == 2">
						<div v-if="entered.whoPay == 1">
							<van-card v-for="(item,index) in orderList" :key="item.id">
								<template #title>
									<h3 style="text-align: justify;margin-top:0;">{{item.commodityName}}</h3>
								</template>
								<template #desc>
									<p style="font-size: 14px;">报名时间:{{item.crtTime}}</p>
								</template>
								<template #price>
									<span style="font-size: 14px;color:#d00;margin-right:20px;font-weight: bold;">￥{{item.money}}</span>
									<van-tag type="warning" style="font-size: 14px;">已支付/参会人支付</van-tag>
								</template>
								<template #thumb>
									<van-image :src=hyImg />
								</template>
								<template #footer>
									
								</template>
							</van-card>
						</div>
						<div v-else-if="entered.whoPay == 2">
							<van-card>
								<template #title>
									<h3 style="text-align: justify; margin-top:0;">{{meeting.meetingName}}</h3>
								</template>
								<template #desc>
									<p style="font-size: 14px;">报名时间:{{entered.crtTime}}</p>
								</template>
								<template #price>
									<span style="font-size: 14px;color:#d00;margin-right:20px;font-weight: bold;">￥{{entered.money}}</span>
									<van-tag type="warning" style="font-size: 14px;">已支付/经办人支付</van-tag>
								</template>
								<template #thumb>
									<van-image :src=hyImg />
								</template>
								<template #footer>
								</template>
							</van-card>
						</div>
						<div v-else-if="entered.whoPay == 0">
							<van-card>
								<template #title>
									<h3 style="text-align: justify;margin-top:0;">{{meeting.meetingName}}</h3>
								</template>
								<template #desc>
									<p style="font-size: 14px;">报名时间:{{entered.crtTime}}</p>
								</template>
								<template #price>
									<span style="font-size: 14px;color:#d00;" v-if="entered.transferStatus==2">转赠票</span>
									<span v-else style="font-size: 14px;color:#d00;">免费</span>
								</template>
								<template #thumb>
									<van-image :src=hyImg />
								</template>
								<template #footer>
								</template>
							</van-card>
						</div>
					</div>
				</div>
				<div style="margin:40px 16px 16px;"><van-button round block type="info" size="22"
						@click="logOut">退出</van-button></div>
			</div>
		</div>
	</div>
</template>

<script>
	import QrcodeVue from "qrcode.vue";
	export default {
		components: {
			QrcodeVue
		},
		data() {
			return {
				userImg: require('@/assets/images/touxiang.png'),
				hyImg: require('@/assets/images/hyimg.jpg'),
				chmShow: false,
				ewmUrl: "",
				size: 202,
				userName: "",
				userPhone: "",
				userType: "",
				isBmf: "",
				isEnterprisesParticipating: "",
				orderData: "",
				payStatus: "",
				attr2: true,
				attr2badge: "",
				invoiceIsjy:true,
				invoiceInfobadge : '',
				meeting: "",
				entered: "",
				teamOperator: "",
				meetingName: "",
				meetingTime: "",
				meetingAddress: "",
				money: "",
				outTradeNo: "",
				meetingCode: "",
				code: "",
				isTeamOperator: '',
				orderList:[]
			};
		},
		created() {
			this.toEnteredCenter();
		},
		methods: {
			dynamicPath(name) {
				if (name == '团体成员管理') {
					this.$router.push('/personal/teammember?meetingCode=' + this.meetingCode);
				} else if (name == '交费管理') {
					this.$router.push('/personal/paymentmanagement?meetingCode=' + this.meetingCode);
				} else if (name == '订单管理') {
					this.$router.push('/personal/ordermanagement?meetingCode=' + this.meetingCode);
				} else if (name == '转赠') {
					console.log(this);
					this.$dialog.confirm({
						title: '操作',
						message: '确定转赠您的入场票？本操作无法撤回，请谨慎操作。',
					})
					.then(() => {
						this.$router.push('/personal/applyTransfer?meetingCode=' + this.meetingCode);
					})
					.catch(() => {
						// on cancel
					});
				}
				//  else { //发票管理
				// 	this.$router.push('/personal/invoicesmanagement?meetingCode=' + this.meetingCode);
				// }
				// 根据某些条件计算路径
			},
			toEnteredCenter() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				// console.log(hyMeetingId);
				// if(!sessionStorage.getItem('openid')){
				//   var local = window.location.href; // 获取页面url
				//   if(process.env.API_ROOT == 'https://meeting.ejectu.com'){
				//     var appid = 'wxb6f979941a7e9ef7';
				//   }else{
				//     var appid = 'wxf10c045e4ea571fe';
				//   }
				//   this.code = this.getUrlCode().code;// 截取code
				//   if (this.code == null || this.code === ''){
				//       window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
				//   }else{
				//     this.getUserInfoByCode();
				//   }
				// }
				console.log(hyMeetingId, token);
				if (hyMeetingId && token) {
					this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, {
							headers: {
								Authorization: ` ${token}`
							}
						}).then((res) => {
							console.log(res.data);
							if (res.data.status == 200) {
								const entered = res.data.data.entered;
								const meeting = res.data.data.meeting;
								const order = res.data.data.order;
								this.teamOperator = res.data.data.teamOperator;
								if (res.data.data.isTeamOperator) {
									this.isTeamOperator = res.data.data.isTeamOperator;
								}
								this.meeting = meeting;
								this.entered = entered;
								this.order = order;
								this.orderList = res.data.data.orderList;
								this.meetingName = meeting.meetingName;
								this.meetingCode = meeting.code;
								this.isBmf = meeting.isBmf;
								this.isEnterprisesParticipating = meeting.isEnterprisesParticipating;
								if (entered) {
									this.meetingTime = entered.crtTime;
									this.userName = entered.name;
									this.userPhone = entered.phone;
									this.userType = entered.userType;
									this.ewmUrl = entered.ewmUrl;
									sessionStorage.setItem('userName', entered.name);
									sessionStorage.setItem('userPhone', entered.phone);
									if (this.$moment().valueOf() > this.$moment(meeting.scoreDeadline).valueOf()) {
										this.attr2 = false;
										this.attr2badge = '已结束';
										return false;
									}
									if (entered.attr2) {
										this.attr2 = false;
										this.attr2badge = '已申请';
									}
									if (this.$moment().valueOf() > this.$moment(meeting.invoiceDeadline).valueOf()) {
										this.invoiceIsjy = false;
										this.invoiceInfobadge = '已结束';
										return false;
									}
									if (JSON.parse(entered.extendParam).invoiceInfo.invoiceTitle) {
										this.invoiceIsjy = false;
										this.invoiceInfobadge = '已申请';
									}
								}
								
								this.meetingAddress = meeting.meetingAddress;
								if (order) {
									this.money = order.money;
									this.outTradeNo = order.outTradeNo;

									if (order.orderInvoice) {
										localStorage.setItem('orderInvoice', order.orderInvoice)
									} else {
										localStorage.removeItem('orderInvoice')
									}
								} else {
									this.money = '免费';
								}
								
								

								
								this.payStatus = order ? order.payStatus : null;
								localStorage.setItem('sqfpEndTime', this.$moment(meeting.invoiceDeadline)
									.format("MM月DD日"));
								localStorage.setItem('sqxfEndTime', this.$moment(meeting.scoreDeadline)
									.format("MM月DD日"));
								console.log(this.$moment(meeting.endTime).add(30, 'days').valueOf());
								console.log(this.$moment().valueOf());

							} else {
								localStorage.removeItem('sessionGrzxToken_' + hyMeetingId);
								this.$router.push('/personal/login?meetingId=' + hyMeetingId);
							}

						})
						.catch((err) => {
							//localStorage.removeItem('sessionGrzxToken_' + hyMeetingId);
							
							//this.$router.push('/personal/login?meetingId=' + hyMeetingId);
						})
				} else {
					// this.$router.push('/personal/login?meetingId='+hyMeetingId);
				}

			},
			chm() {
				this.chmShow = true;
				// window.open('http://m.yq.itnascn.com/#/login','_blank');
			},
			sqxf() {
				// if(this.attr2){
				//   this.$router.push('/personal/sqxf');
				// }else if(this.attr2badge =='已结束'){
				//   this.$toast.fail('申请学分已结束');
				// }else{
				//   this.$toast.fail('申请学分已提交');
				// }
				this.$router.push('/personal/sqxf');
			},
			/**
			 * 获取URL参数
			 * @returns {Object}
			 */
			getUrlCode() {
				var url = location.search
				var theRequest = new Object()
				if (url.indexOf("?") != -1) {
					var str = url.substr(1)
					var strs = str.split("&")
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
					}
				}
				return theRequest
			},
			getUserInfoByCode() {
				this.axios.get('/api/appweb/wxpay/getUserInfoByCode?code=' + this.code).then(res => {
					var openid = res.data.data.openid;
					sessionStorage.setItem('openid', openid);
					// console.log(res);
					this.$router.push("/personal/index");
				});
			},
			zhifu() {
				this.$cookies.set('cookies_meeting_order_payMoney', this.order.money);
				this.$cookies.set('cookise_order_outTradeNo', this.order.outTradeNo);
				this.$router.push('/charge/pay');
			},
			wysj() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				this.axios.get('/api/appweb/entered/upgradedUser/' + hyMeetingId, {
					headers: {
						Authorization: ` ${token}`
					}
				}).then((res) => {
					const data = res.data.data;
					if (res.data.status == 200) {
						this.money = data.payMoney;
						this.outTradeNo = data.outTradeNo;
						this.$cookies.set('cookies_meeting_order_payMoney', this.money);
						this.$cookies.set('cookise_order_outTradeNo', this.outTradeNo);
						this.$router.push('/charge/pay');
					}

				})
			},
			enteredApplyRefund(phone){
				if(new Date(this.meeting.refundDeadline) <= new Date()){
					this.$dialog.alert({
						message:`<div id="loadContent" style="display:block;text-align:justify;font-size:16px; line-height:26px;text-indent:2em;"><p>MAIC 2026会议已于今日（2026年9月15日）正式开幕，报名系统自动退款通道同步关闭。如您确需办理退款，请于2026年9月21日（含）后，致电代表报名咨询电话进行人工处理。</p><p>咨询电话：010-68790162、68790710</p><p>感谢您的理解与配合。</p></div>`
					})
				}else{
					const hyMeetingId = sessionStorage.getItem('meetingId');
					const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
					this.axios.get('/api/appweb/orderDetails/fapiao/check/'+phone+'/'+hyMeetingId, {
						headers: {
							Authorization: ` ${token}`
						}
					}).then((res) => {
						if (res.data.status == 200) {
							this.$dialog.confirm({
									title: '操作',
									message: '您确定申请退费吗？本操作无法撤回，请谨慎操作。',
								}).then(() => {
								
								var data = {
									meetingId: hyMeetingId,
									enteredId: item.id
								}
								this.axios.post('/api/appweb/entered/applyRefund', data, {
									headers: {
										Authorization: ` ${token}`
									}
								}).then((res) => {
									const data = res.data.data;
									if (res.data.status == 200) {
										this.$dialog.alert({
										  message: '退费申请已提交，审核结果将通过短信发送至您。',
										}).then(() => {
										  // on close
										  this.toEnteredCenter()
										});
									}
								})
							}).catch(() => {
								// on cancel
							});
						}else{
							this.$dialog.alert({
								message:res.data.message
							})
						}
					})
					
				}	
			},
			logOut() {
				this.$dialog.confirm({
						title: '操作',
						message: '确定要退出吗？',
					})
					.then(() => {
						// on confirm
						let hyMeetingId = sessionStorage.getItem('meetingId');
						this.$router.push('/personal/login?meetingId=' + hyMeetingId);
						localStorage.removeItem('sessionGrzxToken_' + hyMeetingId);
						sessionStorage.removeItem('userName');
						sessionStorage.removeItem('userPhone');
						localStorage.removeItem('orderInvoice');
						localStorage.removeItem('sqfpEndTime');
						localStorage.removeItem('sqxfEndTime');
					})
					.catch(() => {
						// on cancel
					});
			}
		}
	};
</script>

<style scoped="scoped">
	img {
		width: 100%;
		height: auto;
		display: block;
		border: 0;
	}

	.r-line {
		position: relative;
	}

	.r-line:after {
		content: '';
		position: absolute;
		z-index: 0;
		top: 0;
		right: 0;
		height: 100%;
		border-right: 1px solid #d9d9d9;
		-webkit-transform: scaleX(0.5);
		transform: scaleX(0.5);
		-webkit-transform-origin: 100% 0;
		transform-origin: 100% 0;
	}

	.b-line {
		position: relative;
	}

	.b-line:after {
		content: '';
		position: absolute;
		z-index: 2;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1px;
		border-bottom: 1px solid #e2e2e2;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
		-webkit-transform-origin: 0 100%;
		transform-origin: 0 100%;
	}

	.aui-arrow {
		position: relative;
		padding-right: 0.8rem;
		color: #7f8699;
		font-size: 0.85rem;
	}

	.aui-arrow span {
		font-size: 0.8rem;
		color: #9b9b9b;
	}

	.aui-arrow:after {
		content: ' ';
		display: inline-block;
		height: 6px;
		width: 6px;
		border-width: 2px 2px 0 0;
		border-color: #848484;
		border-style: solid;
		-webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: relative;
		top: -2px;
		position: absolute;
		top: 50%;
		margin-top: -4px;
		right: 2px;
		border-radius: 1px;
	}

	.aui-flex {
		text-align: center;
		padding: 15px;
		position: relative;
	}

	.aui-flex-box {
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		min-width: 0;
		font-size: 14px;
		color: #333;
	}

	.aui-flexView {
		width: 100%;
		height: 100%;
		margin: 0 auto;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		flex-direction: column;
		background: #f7f7f7;
	}

	.aui-scrollView {
		width: 100%;
		height: 100%;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		-ms-flex: 1;
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		position: relative;
		padding-bottom: 53px;
	}

	.aui-navBar {
		height: 44px;
		position: relative;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		z-index: 102;
		background-color: #27dbb5;
		background: -webkit-linear-gradient(to right, #27dbb5, #0ba0dd);
		background: -o-linear-gradient(to right, #27dbb5, #0ba0dd);
		background: -moz-linear-gradient(to right, #27dbb5, #0ba0dd);
		background: linear-gradient(to right, #27dbb5, #0ba0dd);
	}

	.aui-navBar-item {
		height: 44px;
		min-width: 15%;
		-webkit-box-flex: 0;
		-webkit-flex: 0 0 15%;
		-ms-flex: 0 0 15%;
		flex: 0 0 15%;
		padding: 0 0.9rem;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		font-size: 0.7rem;
		white-space: nowrap;
		overflow: hidden;
		color: #808080;
		position: relative;
	}

	.aui-navBar-item:first-child {
		-webkit-box-ordinal-group: 2;
		-webkit-order: 1;
		-ms-flex-order: 1;
		order: 1;
		margin-right: -25%;
		font-size: 0.9rem;
		font-weight: bold;
	}

	.aui-navBar-item:last-child {
		-webkit-box-ordinal-group: 4;
		-webkit-order: 3;
		-ms-flex-order: 3;
		order: 3;
		-webkit-box-pack: end;
		-webkit-justify-content: flex-end;
		-ms-flex-pack: end;
		justify-content: flex-end;
		font-size: 14px;
		color: #333333;
	}

	.aui-center {
		-webkit-box-ordinal-group: 3;
		-webkit-order: 2;
		-ms-flex-order: 2;
		order: 2;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		height: 44px;
		width: 80%;
		margin-left: 10%;
	}

	.aui-center-title {
		text-align: center;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		display: block;
		text-overflow: ellipsis;
		font-size: 0.95rem;
		color: white;
	}


	.aui-flex-box h1 {
		color: #303741;
		font-weight: 500;
		font-size: 1rem;
		overflow: hidden;
	}

	.aui-flex-box h2 {
		color: #303741;
		font-weight: 500;
		font-size: 1rem;
		margin-bottom: 0.5rem;
	}

	.aui-flex-box p {
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-all;
		text-overflow: ellipsis;
		font-size: 0.9rem;
		margin-bottom: 0.1rem;
		color: #676767;
	}

	.aui-flex-box h3 {
		font-size: 0.9rem;
		color: #8a8a8a;
		font-weight: normal;
		width: 100%;
		overflow: hidden;
		margin-bottom: 0.3rem;
	}

	.aui-palace {
		padding: 0.6rem 0;
		position: relative;
		overflow: hidden;
	}

	.aui-palace-grid {
		position: relative;
		float: left;
		padding: 1px;
		width: 33.333%;
		box-sizing: border-box;
		margin: 10px 0;
	}

	.aui-palace-grid-icon {
		width: 45px;
		height: 45px;
		margin: 0 auto;
	}

	.aui-palace-grid-icon img {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
	}

	.aui-palace-grid-text {
		display: block;
		text-align: center;
		color: #333;
		font-size: 0.85rem;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		padding-top: 0.5rem;
	}

	.aui-palace-grid-text h2 {
		font-size: 0.8rem;
		font-weight: normal;
		color: #333;
	}

	.aui-palace-grid h2 {
		font-size: 1.2rem;
		font-weight: normal;
		color: #333;
		text-align: center;
	}

	.aui-palace-grid p {
		font-size: 0.85rem;
		font-weight: normal;
		color: #b4cbd5;
		text-align: center;
	}

	.aui-white-bg-pa {
		margin-top: 170px;
	}

	.aui-bg-box {
		background-image: url(../../assets/images/grzxbg.png);
		padding-bottom: 10px;
		height: 10rem;
		background-position: top center;
		background-size: 100%;
		background-repeat: no-repeat;
	}

	.aui-user-box {
		width: 92%;
		height: auto;
		background: white;
		margin: -150px auto;
		border-radius: 10px;
		position: relative;
		box-shadow: 0 5px 10px #dedede;
	}

	.aui-white-bg {
		background: white;
	}

	.aui-palace-one .aui-palace-grid {
		width: 25%;
	}

	.aui-palace-one .aui-palace-grid-icon {
		width: 25px;
		height: 25px;
	}

	.aui-palace-one .aui-palace-grid h2 {
		color: #3f3f3f;
		font-size: 0.9rem;
	}

	.aui-white-bg-pa .aui-flex {
		padding: 15px 20px 0 20px;
	}

	.aui-user-img {
		width: 70px;
		overflow: hidden;
		border-radius: 100px;
		margin: 0 auto;
	}

	.aui-cou-img {
		width: 20px;
		height: 20px;
		margin-right: 0.5rem;
	}

	.aui-cou-img img {
		width: 20px;
		height: 20px;
		display: block;
		border: none;
	}

	.aui-list-item {
		background: white;
		margin-top: 15px;
	}

	.aui-user-box .aui-flex-box h2 {
		color: #3e3e3e;
		font-size: 1.2rem;
		margin-bottom: 0;
		margin-top: 5px;
	}

	.aui-user-box .aui-flex-box p {
		color: #c4d1d7;
		font-size: 1rem;
		margin-top: 10px;
	}

	.aui-tes button {
		background-color: #ff9c3c;
		background: -webkit-linear-gradient(to right, #ff9c3c, #fb731c);
		background: -o-linear-gradient(to right, #ff9c3c, #fb731c);
		background: -moz-linear-gradient(to right, #ff9c3c, #fb731c);
		background: linear-gradient(to right, #ff9c3c, #fb731c);
		border: none;
		color: #fff;
		border-radius: 100px 10px 10px 100px;
		padding: 4px 10px;
		font-size: 0.85rem;
		position: absolute;
		right: -5px;
		top: 35px;
	}

	.aui-footer {
		width: 100%;
		position: relative;
		z-index: 100;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		padding: 7px 5px 7px 5px;
		background: #fefefe;
	}

	.aui-footer:after {
		content: '';
		position: absolute;
		z-index: 0;
		top: 0;
		left: 0;
		width: 100%;
		height: 1px;
		border-top: 1px solid #d6d7dc;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
	}

	.aui-tabBar-item {
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		-ms-flex: 1;
		flex: 1;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		color: #979797;
		position: relative;
	}

	.aui-tabBar-item-text {
		display: inline-block;
		font-size: 0.65rem;
		color: #7f8699;
		padding-top: 2px;
	}

	.aui-tabBar-item-active .aui-tabBar-item-text {
		color: #24d5b9;
	}

	.grzxBlock {
		margin: 4% 4% 10%;
	}

	.grzxBlock h2.title {
		text-align: justify;
		font-size: 1.4rem;
		line-height: 2.2rem;
	}

	.chmContent {
		position: relative;
		padding: 5px;
		width: 210px;
		margin: 20px auto 0;
	}

	.chmContent .chmewm {
		position: relative;
		padding: 4px;
		background: #fff;
		width: 202px;
	}

	.product-hover {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		-webkit-transition: opacity 0.3s ease;
		-moz-transition: opacity 0.3s ease;
		transition: opacity 0.3s ease;
		background-size: 30px 30px;
		background-image: -webkit-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: -moz-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		-webkit-animation: barberpole 0.5s linear infinite;
		-moz-animation: barberpole 0.5s linear infinite;
		animation: barberpole 0.5s linear infinite;
	}

	@-webkit-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@-moz-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	.van-info {
		min-width: 46px;
		padding: 2px 0;
	}

	.dhCard {
		margin: 20px 0;
		background-color: #17b9cd;
		padding: 10px 20px 3px;
		color: #fff;
		border-radius: 4px;
	}

	.dhCard h4 {
		margin: 0;
		line-height: 30px;
	}

	.dhCard p {
		margin: 10px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Personal/index.vue